module.exports = __webpack_public_path__ + "img/close.9d3a2d9c.svg";